import '@fontsource-variable/inter';
import './app/styles/index.css';
import { createBrowserHistory } from 'history';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App';
import { appStarted } from './app/model';
import { $locale } from './entities/preferences';
import { initI18n } from './shared/lib/i18n';
import { router } from './shared/routing';

const i18n = initI18n($locale.getState());
router.setHistory(createBrowserHistory());
appStarted();

const root = document.getElementById('root');
if (!root) throw new Error('#root is missing from index.html');
createRoot(root).render(
  <StrictMode>
    <App i18n={i18n} />
  </StrictMode>,
);
